import moment from "moment";
import React from "react";
import ItineraryDay from "./ItineraryDay";

interface Props {
  showId: number
  artist: server.dto.ArtistSmall
  appointments: server.dto.PlannerDay[]
  startMoment: moment.Moment
  endMoment: moment.Moment

  linkedFlightSegmentIds: number[]
  linkedGroundTransportIds: number[]
  linkedTrainSegmentIds: number[]

  toggleLinked: (appointment: server.dto.PlannerAppointment) => void

  canCreateNewAppointment: boolean
  canLinkUnlinkTravel: boolean
}

const Itinerary = (props: Props) => {
  const [hoveringOver, setHoveringOver] = React.useState<server.dto.PlannerAppointment>(null);

  return (<table className="s1_table s1_itinerarysidebar">
    <tbody>
      {props.appointments.map(appDate =>
        <ItineraryDay
          artist={props.artist}
          showId={props.showId}
          key={moment.utc(appDate.date).valueOf()}
          dayAppointments={appDate}
          linkedFlightSegmentIds={props.linkedFlightSegmentIds}
          linkedGroundTransportIds={props.linkedGroundTransportIds}
          linkedTrainSegmentIds={props.linkedTrainSegmentIds}
          toggleLinked={props.toggleLinked}
          onHoveringOver={setHoveringOver}
          hoveringOver={hoveringOver}
          canCreateNewAppointment={props.canCreateNewAppointment}
          canLinkUnlinkTravel={props.canLinkUnlinkTravel}
        />)}
    </tbody>
  </table>);
};
export default Itinerary;